<template>
  <TimeTrackerEvent dto_model="TimeTrackerEventDateAggregateDTO"></TimeTrackerEvent>
</template>

<script>
import TimeTrackerEvent from "@/components/TimeTracker/TimeTrackerEvent";


export default {
  name: 'TimeTrackerAggregateEvent',
  props: {
  },

  components: {
    TimeTrackerEvent,
  },

}
</script>

<style scoped lang="scss">

</style>
